export class WindowState {
  tab: string = "";
  expanded: boolean = false;
}
